import { useCallback, useRef, useState } from 'react';

/** Copies text; falls back to selecting `select` when the clipboard is not available. Returns a short label. */
export function useCopy(label: string): [string, (text: string, select?: HTMLElement | null) => void] {
  const [msg, setMsg] = useState(label);
  const t = useRef<ReturnType<typeof setTimeout> | null>(null);
  const copy = useCallback((text: string, select?: HTMLElement | null) => {
    const done = (m: string) => { setMsg(m); if (t.current) clearTimeout(t.current); t.current = setTimeout(() => setMsg(label), 1600); };
    const fallback = () => {
      if (select instanceof HTMLInputElement || select instanceof HTMLTextAreaElement) { select.focus(); select.select(); }
      else if (select) { const r = document.createRange(); r.selectNodeContents(select); const s = getSelection(); s?.removeAllRanges(); s?.addRange(r); }
      done('Selected');
    };
    try { navigator.clipboard.writeText(text).then(() => done('Copied'), fallback); } catch { fallback(); }
  }, [label]);
  return [msg, copy];
}
